define('components/PostContent',[
    "jquery",
    "logging"
], function ($, logging) {
    var _ModuleName = "Post Content";

    function PostContent(scope, config) {
        "use strict";

        // Add the class "decorated-link" to all anchor tags under the .story-block class.
        $(".story-block a").addClass("decorated-link");

        // Removes the class "decorated-link" to all anchor tags under the .patheos-gallery class.
        $(".story-block .patheos-gallery a").removeClass("decorated-link");

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new PostContent(args.scope, args.Config);
        }
    }
});
